"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _a, _b, _c, _d, _e;
"use strict";
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const moment_1 = __importDefault(require("moment"));
const __1 = require("..");
const Command_1 = require("../Command");
class OMSession extends __1.OMObject {
    constructor(object) {
        super(object);
        this.token = object.token;
        this.refreshToken = object.refreshToken;
        this.invalidatedAt = object.invalidatedAt && moment_1.default(object.invalidatedAt);
        this.user = new __1.OMReference(__1.OMUser, object.user);
        this.installation = object.installation && new __1.OMReference(__1.Installation, object.installation);
        this.tokenDecoded = jwt_decode_1.default(object.token);
        this.refreshTokenDecoded = jwt_decode_1.default(object.refreshToken);
        this.tokenExpiresAt = moment_1.default(this.tokenDecoded.exp * 1000);
        this.refreshTokenExpiresAt = moment_1.default(this.refreshTokenDecoded.exp * 1000);
        this.utmSource = object.utmSource;
        this.utmMedium = object.utmMedium;
        this.utmCampaign = object.utmCampaign;
        this.utmTerm = object.utmTerm;
        this.utmContent = object.utmContent;
    }
    get hasExpired() {
        return this.tokenExpiresAt.isValid()
            ? this.tokenExpiresAt.clone().isSameOrBefore(moment_1.default().add(OMSession.timeDriftInMilliseconds))
            : true;
    }
    get refreshTokenHasExpired() {
        return this.refreshTokenExpiresAt.isValid()
            ? this.refreshTokenExpiresAt.clone().isSameOrBefore(moment_1.default().add(OMSession.timeDriftInMilliseconds))
            : true;
    }
    get isRenewable() {
        return this.refreshTokenExpiresAt.isValid();
    }
    get shouldRenewAt() {
        return this.tokenExpiresAt.isValid()
            ? this.tokenExpiresAt.clone().add(OMSession.timeDriftInMilliseconds).subtract(1, "minute")
            : moment_1.default();
    }
    get shouldExtendAt() {
        return this.tokenExpiresAt.isValid()
            ? this.tokenExpiresAt.clone().add(OMSession.timeDriftInMilliseconds).subtract(1, "minute")
            : moment_1.default();
    }
    get refreshTimeIntervalInMilliSeconds() {
        return this.shouldRenewAt.diff(moment_1.default());
    }
    static isType(object) {
        return object &&
            object.hasOwnProperty("token") &&
            object.hasOwnProperty("refreshToken");
    }
    // tslint:disable-next-line
    static generateActiveUsersGraph(startDate, endDate) {
        try {
            const command = new OMSession.GenerateActiveUsersGraphCommand(OMSession, startDate, endDate);
            return Command_1.CommandManager.shared.addToQueue(command);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    // tslint:disable-next-line
    static averageLength(startDate, endDate) {
        try {
            const command = new OMSession.AverageLengthCommand(OMSession, startDate, endDate);
            return Command_1.CommandManager.shared.addToQueue(command);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    // tslint:disable-next-line
    setUtmTags(utmSource = null, utmMedium = null, utmCampaign = null, utmTerm = null, utmContent = null) {
        try {
            // tslint:disable-next-line
            const command = new OMSession.SetUtmTagsCommand(this, utmSource, utmMedium, utmCampaign, utmTerm, utmContent);
            return (() => __awaiter(this, void 0, void 0, function* () {
                const response = yield Command_1.CommandManager.shared.addToQueue(command);
                this.utmSource = utmSource || undefined;
                this.utmMedium = utmMedium || undefined;
                this.utmCampaign = utmCampaign || undefined;
                this.utmTerm = utmTerm || undefined;
                this.utmContent = utmContent || undefined;
                __1.OMUniverse.shared.touch(this);
                return response;
            }))();
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    renew() {
        return __awaiter(this, void 0, void 0, function* () {
            const command = new OMSession.RenewCommand(this);
            return yield Command_1.CommandManager.shared.addToQueue(command);
        });
    }
    extend() {
        return __awaiter(this, void 0, void 0, function* () {
            const command = new OMSession.ExtendCommand(this);
            return yield Command_1.CommandManager.shared.addToQueue(command);
        });
    }
    toJSON() {
        return Object.assign({}, this, { installation: undefined });
    }
}
// tslint:disable-next-line
OMSession.timeDriftInMilliseconds = parseInt(localStorage.getItem("timeDriftInMilliseconds") || "", 10) || 0;
OMSession.Type = "session";
OMSession.Path = "sessions";
OMSession.SetUtmTagsCommand = (_a = class SetUtmTagsCommand extends Command_1.Command {
        constructor(receiver, utmSource, utmMedium, utmCampaign, utmTerm, utmContent) {
            super(receiver);
            this.utmSource = utmSource;
            this.utmMedium = utmMedium;
            this.utmCampaign = utmCampaign;
            this.utmTerm = utmTerm;
            this.utmContent = utmContent;
        }
    },
    _a.Path = "set_utm_tags",
    _a.Type = "session_set_utm_tags_command",
    _a);
OMSession.GenerateActiveUsersGraphCommand = (_b = class GenerateActiveUsersGraphCommand extends Command_1.Command {
        constructor(receiver, startDate, endDate) {
            super(receiver);
            this.startDate = startDate;
            this.endDate = endDate;
        }
    },
    _b.Path = "generate_active_users_graph",
    _b);
OMSession.AverageLengthCommand = (_c = class AverageLengthCommand extends Command_1.Command {
        constructor(receiver, startDate, endDate) {
            super(receiver);
            this.startDate = startDate;
            this.endDate = endDate;
        }
    },
    _c.Path = "average_length",
    _c);
OMSession.RenewCommand = (_d = class RenewCommand extends Command_1.Command {
        constructor(receiver) {
            super(receiver);
            this.refreshToken = receiver.refreshToken;
        }
        execute() {
            const _super = name => super[name];
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield __1.OMUniverse.shared.extendOrRenewSessionPromise;
                    const extendOrRenewSessionPromise = (() => __awaiter(this, void 0, void 0, function* () {
                        const requestTime = moment_1.default();
                        const response = yield _super("execute").call(this);
                        const sessions = __1.OMUniverse.shared.apiClient.objectsFromResponse(OMSession, response.data);
                        if (sessions.length === 0) {
                            throw new Error("Expecting Session object");
                        }
                        OMSession.timeDriftInMilliseconds = requestTime.diff(sessions[0].modifiedAt);
                        localStorage.setItem("timeDriftInMilliseconds", requestTime.diff(sessions[0].modifiedAt).toString());
                        __1.OMUniverse.shared.setSession(sessions[0]);
                        return response;
                    }))();
                    __1.OMUniverse.shared.extendOrRenewSessionPromise = extendOrRenewSessionPromise;
                    return yield extendOrRenewSessionPromise;
                }
                catch (error) {
                    if (error &&
                        error.response &&
                        error.response.data &&
                        error.response.data.errors &&
                        error.response.data.errors[0] &&
                        ((error.response.data.errors[0].title === "Session Blacklisted" ||
                            error.response.data.errors[0].detail === "jwt expired")
                            ||
                                (error.response.data.errors[0].title === "Invalid Installation"))) {
                        __1.OMUniverse.shared.clearUserSession();
                        if (typeof document !== "undefined") {
                            document.location.reload();
                        }
                    }
                    throw error;
                }
                finally {
                    __1.OMUniverse.shared.extendOrRenewSessionPromise = null;
                }
            });
        }
    },
    _d.Path = "renew",
    _d);
OMSession.ExtendCommand = (_e = class RenewCommand extends Command_1.Command {
        execute() {
            const _super = name => super[name];
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield __1.OMUniverse.shared.extendOrRenewSessionPromise;
                    const extendOrRenewSessionPromise = (() => __awaiter(this, void 0, void 0, function* () {
                        const requestTime = moment_1.default();
                        const response = yield _super("execute").call(this);
                        const sessions = __1.OMUniverse.shared.apiClient.objectsFromResponse(OMSession, response.data);
                        if (sessions.length === 0) {
                            throw new Error("Expecting Session object");
                        }
                        OMSession.timeDriftInMilliseconds = sessions[0].modifiedAt.diff(requestTime);
                        localStorage.setItem("timeDriftInMilliseconds", requestTime.diff(sessions[0].modifiedAt).toString());
                        __1.OMUniverse.shared.setSession(sessions[0]);
                        return response;
                    }))();
                    __1.OMUniverse.shared.extendOrRenewSessionPromise = extendOrRenewSessionPromise;
                    return yield extendOrRenewSessionPromise;
                }
                catch (error) {
                    // fallback mechanism for project that does not have OMSession::extend
                    if (error &&
                        error.response &&
                        error.response.data &&
                        error.response.data.errors &&
                        error.response.data.errors[0] &&
                        (error.response.data.errors[0].detail === 'Cannot perform "extend" on receiver type "session"' ||
                            error.response.data.errors[0].detail === "Your session has expired.")) {
                        __1.OMUniverse.shared.extendOrRenewSessionPromise = null;
                        return __1.OMUniverse.shared.session && __1.OMUniverse.shared.session.renew();
                    }
                    if (error &&
                        error.response &&
                        error.response.data &&
                        error.response.data.errors &&
                        error.response.data.errors[0] &&
                        (error.response.data.errors[0].title === "Session Blacklisted" ||
                            error.response.data.errors[0].detail === "jwt expired")) {
                        __1.OMUniverse.shared.clearUserSession();
                        if (typeof document !== "undefined") {
                            document.location.reload();
                        }
                    }
                    throw error;
                }
                finally {
                    __1.OMUniverse.shared.extendOrRenewSessionPromise = null;
                }
            });
        }
    },
    _e.Path = "extend",
    _e);
exports.default = OMSession;
//# sourceMappingURL=OMSession.js.map